import React from 'react';

import { FEED_BOTTOM_ELEM_ID } from './constants';
import { BaseThreadFragmentFragmentGQLType } from '../../../types/dashboard-core-gqlTypes.generated.d';
import * as CreditFacilityEntityConfig from '~/core/routes/credit-facilities/EntityConfig';
import * as DeliverableEntityConfig from '~/core/routes/deliverables/EntityConfig';
import * as FundingRequestEntityConfig from '~/core/routes/funding-requests/EntityConfig';
import * as InvoiceEntityConfig from '~/core/routes/invoices/EntityConfig';
import * as LimitedPartnerEntityConfig from '~/core/routes/limited-partners/EntityConfig';
import * as ValleyBankEntityConfig from '~/core/routes/valley-bank/EntityConfig';
import { Typography } from '~/packages/common-frontend/components/Typography';
import { useScrollToAfterAllLoaded } from '~/packages/common-frontend/hooks/useScrollToAfterAllLoaded';

// Fragments
type ThreadFeedProps = {
  threads: BaseThreadFragmentFragmentGQLType[];
  onThreadAction?: () => void;
};
export const ThreadFeed = ({ threads, onThreadAction }: ThreadFeedProps) => {
  const { onReady, onMount } = useScrollToAfterAllLoaded({
    behavior: 'instant',
    scrollTimeout: 250,
    scrollToElemSelector: `#${FEED_BOTTOM_ELEM_ID}`,
  });

  return (
    <>
      {threads.map((thread) => (
        <React.Fragment key={thread.threadId}>
          <CreditFacilityEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
          <DeliverableEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
          <FundingRequestEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
          <LimitedPartnerEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
          <InvoiceEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
          <ValleyBankEntityConfig.ThreadFeedItem
            thread={thread}
            onMount={onMount}
            onReady={onReady}
            onThreadAction={onThreadAction}
          />
        </React.Fragment>
      ))}

      <Typography
        variant="detail-muted"
        TextProps={{
          id: FEED_BOTTOM_ELEM_ID,
          textAlign: 'center',
          marginBlock: '1.5rem',
        }}
      >
        All caught up! 🎉
      </Typography>
    </>
  );
};
